import { z } from "zod";
import { validationError } from "../../globals";

export const registration = z.object({
  success: z.boolean().optional(),
  firebaseUserId: z.string().nullish(),
  validationErrors: z.array(validationError).optional(),
});

export type Registration = z.infer<typeof registration>;
